import { createApp } from "vue";
import App from "./App.vue";
import ClientApp from "./ClientApp.vue";
import "./styles.css";

const isClient = window.location.pathname.startsWith("/client");
const root = isClient ? ClientApp : App;
document.title = isClient ? "AI 交互终端" : "AI 后台管理台";
createApp(root).mount("#app");
